"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.LunaSystemMessageSizes = exports.LunaSystemMessageGlyphs = exports.LunaSystemMessageTypes = exports.LunaSystemMessageVariants = void 0;

var _types, _variants;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaSystemMessageVariants = {
  inline: 'inline',
  toast: 'toast'
};
exports.LunaSystemMessageVariants = LunaSystemMessageVariants;
var LunaSystemMessageTypes = {
  informational: 'informational',
  success: 'success',
  warning: 'warning',
  critical: 'critical'
};
exports.LunaSystemMessageTypes = LunaSystemMessageTypes;
var LunaSystemMessageGlyphs = {
  informational: 'info',
  success: 'success-stroke',
  warning: 'flag-stroke',
  critical: 'warning-stroke'
};
exports.LunaSystemMessageGlyphs = LunaSystemMessageGlyphs;
var LunaSystemMessageSizes = {
  small: 'small'
};
exports.LunaSystemMessageSizes = LunaSystemMessageSizes;
var __baseClass = 'luna-system_message';
var classes = {
  action: "".concat(__baseClass, "--action"),
  actionButton: "".concat(__baseClass, "--action_button"),
  base: __baseClass,
  closeAction: "".concat(__baseClass, "--close_action"),
  closeActionIcon: "".concat(__baseClass, "--close_action_icon"),
  content: "".concat(__baseClass, "--content"),
  contentWrapper: "".concat(__baseClass, "--content_wrapper"),
  disabled: "".concat(__baseClass, "-disabled"),
  fullWidth: "".concat(__baseClass, "-full_width"),
  header: "".concat(__baseClass, "--content_header"),
  icon: "".concat(__baseClass, "--icon"),
  inputVisibility: "".concat(__baseClass, "--content_visibility"),
  labelVisibility: "".concat(__baseClass, "--content_label"),
  types: (_types = {}, _defineProperty(_types, LunaSystemMessageTypes.informational, "".concat(__baseClass, "-informational")), _defineProperty(_types, LunaSystemMessageTypes.success, "".concat(__baseClass, "-success")), _defineProperty(_types, LunaSystemMessageTypes.warning, "".concat(__baseClass, "-warning")), _defineProperty(_types, LunaSystemMessageTypes.critical, "".concat(__baseClass, "-critical")), _types),
  variants: (_variants = {}, _defineProperty(_variants, LunaSystemMessageVariants.inline, "".concat(__baseClass, "-inline")), _defineProperty(_variants, LunaSystemMessageVariants.toast, "".concat(__baseClass, "-toast")), _variants),
  sizes: _defineProperty({}, LunaSystemMessageSizes.small, "".concat(__baseClass, "-small"))
};
exports.classes = classes;
